import formatMessage from 'format-message'
import React from 'react'
import GenerateMergedPDF from './GenerateMergedPDF'

export const statuses = ['None', 'Waiting', 'Done', 'Error']

export default function MergedPDFDownload({ mergedPdfStatus, generateMergedPdf }) {
  switch (mergedPdfStatus) {
    case 'None':
      return (
        <GenerateMergedPDF
          generateMergedPdf={generateMergedPdf}
          text={formatMessage('Download annotated PDF')}
        />
      )
    case 'Waiting':
      return <div>{formatMessage('Please wait...')}</div>
    case 'Error':
      return (
        <GenerateMergedPDF
          generateMergedPdf={generateMergedPdf}
          text={formatMessage('Download annotated PDF')}
        />
      )
    case 'Done':
      return (
        <GenerateMergedPDF
          generateMergedPdf={generateMergedPdf}
          text={formatMessage('Download annotated PDF')}
        />
      )
    default:
      return <span />
  }
}
